var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clearfix"},[_c('ActiveAccount',{staticClass:"chart"}),_c('NewAccount',{staticClass:"chart"}),_c('NewProduct',{staticClass:"chart",staticStyle:{"margin-right":"0"}}),_c('Detail',{attrs:{"visible":_vm.visible},on:{"close":_vm.handleClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }